import { render, staticRenderFns } from "./TaskManagementDetail.vue?vue&type=template&id=71bacedd"
import script from "./TaskManagementDetail.vue?vue&type=script&lang=js"
export * from "./TaskManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./TaskManagementDetail.vue?vue&type=style&index=0&id=71bacedd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports